export var resizeMixin = {
  data: function data() {
    return {
      innerWidth: window.innerWidth
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler: function resizeHandler() {
      this.innerWidth = window.innerWidth;
    }
  },
  computed: {
    isMobile: function isMobile() {
      return this.innerWidth < 768;
    }
  }
};